<template>
  <b-container class="wh-exit-monitor" fluid>
    <div style="position: relative; max-height: 100vh;" id="monitor" :class="viewType === 'tv' ? 'overflow-hidden' : 'overflow-auto'">
      <div id="inner-monitor" style="position:relative">
        <b-row>
          <b-col class="align-self-center py-1">
            <h5>
              <span v-translate="{countdown}">WH Exit Monitor <small>(Autorefresh in %{countdown}s)</small></span>
              <b-link size="sm" class="p-0" v-b-modal.modalConfigMonitor><font-awesome-icon size="sm" icon="cog" /></b-link>
              <b-spinner small v-if="working" /></h5>
          </b-col>
          <b-modal size="sm" id="modalConfigMonitor" ref="modalConfigMonitor" hide-footer hide-header>
            <b-row>
              <b-col class="text-center">
                <b-button-group size="lg">
                  <b-button @click.prevent="viewType = 'tv'; setIntervalChangeScreen(); $refs.modalConfigMonitor.hide();" :disabled="viewType === 'tv'"><font-awesome-icon size="sm" icon="tv" /></b-button>
                  <b-button @click.prevent="viewType = 'list'; if(screenScroller) screenScroller.stop(); screenScroller = null; $refs.modalConfigMonitor.hide();" :disabled="viewType === 'list'"><font-awesome-icon size="sm" icon="list" /></b-button>
                  <b-button @click.prevent="viewType = 'grid'; if(screenScroller) screenScroller.stop(); screenScroller = null;  $refs.modalConfigMonitor.hide();" :disabled="viewType === 'grid'"><font-awesome-icon size="sm" icon="th" /></b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-modal>
          <b-col class="align-self-center py-1">
            <div v-if="warehousesByIdSelect.length > 0">
              <b-form-group class="mb-1">
                <b-form-select size="sm" v-model="filterWarehouse" :options="countryOverride ? warehouses : []">
                  <template slot="first">
                    <option :value="null" v-translate>None</option>
                  </template>
                </b-form-select>
              </b-form-group>
            </div>
          </b-col>
          <b-col class="align-self-center">
            <b-form-group class="mb-1">
              <b-form-select size="sm" v-model="countryOverride" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" @change="setNewCountry" v-if="isInternational">
                <template slot="first">
                  <option :value="null" v-translate>Select Country</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <b-alert variant="warning" :show="connectionError">
          <span v-translate="{countdownConnectionError}">There are connection errors. Retrying in %{countdownConnectionError}s.</span>
        </b-alert>

        <b-alert variant="warning" class="my-3" show v-if="!countryOverride || !filterWarehouse || (countryOverride && warehouses.length === 0)">
          <h4 class="my-0" v-translate>You need to set a Country and the Country must have warehouses set.</h4>
        </b-alert>
        <b-row id="data">
          <b-col cols="12" v-for="(slot, i) in slots" :key="slot.tour.id + i" v-if="viewType === 'list' && countryOverride && warehouses.length > 0 && slots.length > 0">
            <b-card class="mb-1 p-0" :class="rowBg(slot)">
              <b-row class="p-0">
                <b-col cols="2">
                  <b-row>
                    <b-col>
                      <strong>{{slot.code}}</strong> <b-link :to="{ name: 'viewTour', params: {id: slot.tour.id} }" target="_blank" class="text-secondary">#{{slot.tour.id | uuid}}</b-link> <small>({{slot.content.length}}/{{slot.tour.shippings.length}})</small>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="3" md="2">
                  <b-badge class="mr-1" variant="dark" v-for="(item, index) in slot.routingZones" :key="index">
                    {{index}}
                    <small>{{item}}</small>
                  </b-badge>
                </b-col>
                <b-col cols="1" v-if="!slot.badScanneds">
                  <b-row v-if="slot.tour.courier">
                    <b-col v-if="slot.distanceToDestination">
                      <small><strong>{{slot.readableDistanceToDestination}}<br>{{slot.eta}}</strong></small>
                    </b-col>
                    <b-col v-else>
                      <span class="text-danger">
                        <small v-translate>No tracking</small>
                      </span>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col>
                  <div v-if="!slot.badScanneds">
                    <div v-if="slot.tour.courier">
                      <small>#{{slot.tour.courier.id}} <strong>{{slot.tour.courier.name}}</strong>
                      <span v-if="slot.tour.status !== 'FINISHED'"><br>{{slot.tour.courier.phone | phone('ar')}}</span></small>
                    </div>
                  </div>
                  <div v-else>
                    {{slot.badScanneds.join(', ')}}
                  </div>
                </b-col>
                <b-col cols="2">
                  <small>{{slot.tour.total_distance}} km.</small>
                  <b-badge variant="light" v-if="slot.confirmedAt">{{slot.confirmedAt}}</b-badge>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="3" v-for="(slot, i) in slots" :key="slot.tour.id + i" v-if="viewType === 'grid' && countryOverride && warehouses.length > 0 && slots.length > 0">
            <b-card class="mb-1 p-0" :class="rowBg(slot)">
              <b-row class="p-0">
                <b-col cols="5">
                  <small><strong>{{slot.code}} ({{slot.content.length}}/{{slot.tour.shippings.length}})</strong></small>
                  <b-badge variant="light" v-if="slot.confirmedAt">{{slot.confirmedAt}}</b-badge>
                </b-col>
                <b-col cols="7" class="text-right">
                  <b-link :to="{ name: 'viewTour', params: {id: slot.tour.id} }" target="_blank" class="text-secondary">#{{slot.tour.id | uuid}}</b-link><small> - {{slot.tour.total_distance}} km.</small>
                </b-col>
                <b-col cols="12">
                  <div v-if="!slot.badScanneds">
                    <b-row v-if="slot.tour.courier">
                      <b-col>
                        <small>#{{slot.tour.courier.id}} <strong>{{slot.tour.courier.name}}</strong>
                        <span v-if="slot.tour.status !== 'FINISHED'"><br>{{slot.tour.courier.phone | phone('ar')}}</span></small>
                      </b-col>
                      <b-col cols="4" class="text-right" v-if="slot.distanceToDestination">
                        <small><strong>{{slot.readableDistanceToDestination}}<br>{{slot.eta}}</strong></small>
                      </b-col>
                      <b-col cols="4" class="text-right" v-else>
                        <span class="text-danger">
                          <small v-translate>No tracking</small>
                        </span>
                      </b-col>
                    </b-row>
                  </div>
                  <div v-else>
                    {{slot.badScanneds.join(', ')}}
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-badge class="mr-1" variant="dark" v-for="(item, index) in slot.routingZones" :key="index">
                    {{index}}
                    <small>{{item}}</small>
                  </b-badge>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" :class="i === currentScreen ? 'd-block' : 'd-none'" v-for="(status, i) in statuses" :key="status" v-if="viewType === 'tv' && countryOverride && warehouses.length > 0 && slots.length > 0">
            <b-row>
              <b-col cols="3" v-for="(slot, i) in slots.filter(x => x.status === status)" :key="slot.tour.id + i" v-if="slots.filter(x => x.status === status).length > 0">
                <b-card class="mb-1 p-0" :class="rowBg(slot)">
                  <b-row class="p-0">
                    <b-col cols="5">
                      <small><strong>{{slot.code}} ({{slot.content.length}}/{{slot.tour.shippings.length}})</strong></small>
                      <b-badge variant="light" v-if="slot.confirmedAt">{{slot.confirmedAt}}</b-badge>
                    </b-col>
                    <b-col cols="7" class="text-right">
                      #{{slot.tour.id | uuid}}<small> - {{slot.tour.total_distance}} km.</small>
                    </b-col>
                    <b-col cols="12">
                      <div v-if="!slot.badScanneds">
                        <b-row v-if="slot.tour.courier">
                          <b-col>
                            <small>#{{slot.tour.courier.id}} <strong>{{slot.tour.courier.name}}</strong>
                            <span v-if="slot.tour.status !== 'FINISHED'"><br>{{slot.tour.courier.phone | phone('ar')}}</span></small>
                          </b-col>
                          <b-col cols="4" class="text-right" v-if="slot.distanceToDestination">
                            <small><strong>{{slot.readableDistanceToDestination}}<br>{{slot.eta}}</strong></small>
                          </b-col>
                          <b-col cols="4" class="text-right" v-else>
                            <span class="text-danger">
                              <small v-translate>No tracking</small>
                            </span>
                          </b-col>
                        </b-row>
                      </div>
                      <div v-else>
                        {{slot.badScanneds.join(', ')}}
                      </div>
                    </b-col>
                    <b-col cols="12">
                      <b-badge class="mr-1" variant="dark" v-for="(item, index) in slot.routingZones" :key="index">
                        {{index}}
                        <small>{{item}}</small>
                      </b-badge>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col cols="12" class="text-center mt-3" v-if="slots.filter(x => x.status === status).length === 0">
                <h6 v-translate="{status: status.toUpperCase()}">No %{status} slots</h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-container>
</template>

<script>
import Zenscroll from 'zenscroll'

export default {
  name: 'whExitMonitor',
  data() {
    return {
      slots: [],
      filterWarehouse: null,
      warehouses: [],
      window: window,
      countryOverride: null,
      averageSpeed: 35,
      timeout: null,
      intervalCountdown: null,
      countdown: 60,
      connectionError: false,
      intervalConnectionError: null,
      countdownConnectionError: 10,
      working: false,
      statuses: ['error', 'processing', 'ready'],
      viewType: 'tv',
      countdownChangeScreen: 20,
      intervalChangeScreen: null,
      currentScreen: 0,
      screenScroller: null
    }
  },
  watch: {
    filterWarehouse(val) {
      if (val && this.countryOverride) {
        this.getSlots()
      } else {
        this.clearTimeout()
        this.slots = []
      }
    },
    countryOverride(val) {
      if (val) {
        this.getSlots()
      } else {
        this.clearTimeout()
        this.slots = []
      }
    },
    warehousesByIdSelect(val) {
      if (val) {
        this.warehouses = val
      } else {
        this.warehouses = []
      }
    }
  },
  created() {
    this.fetchWarehousesById()
  },
  mounted() {
    this.countryOverride = this.$cookies.get('country') && !this.$cookies.get('bypassCountry') ? this.$cookies.get('country') : null
    this.warehouses = this.warehousesByIdSelect
    this.filterWarehouse = this.$cookies.get('warehouse') || null
    this.setIntervalChangeScreen()
  },
  methods: {
    setIntervalChangeScreen() {
      if (this.viewType === 'tv') {
        this.countdownChangeScreen = this.slots.filter(x => x.status === this.statuses[this.currentScreen]).length * 2
        this.countdownChangeScreen = this.countdownChangeScreen > 30 ? 30 : (this.countdownChangeScreen === 0 ? 3 : (this.countdownChangeScreen < 10 ? 10 : this.countdownChangeScreen))
        this.intervalChangeScreen = setTimeout(function () {
          this.screenScroller = null
          this.currentScreen = this.currentScreen === this.statuses.length - 1 ? 0 : this.currentScreen + 1
          this.$nextTick(() => {
            if (!this.isInViewport(document.getElementById('inner-monitor'))) {
              this.scrollDown()
            }
          })
          this.setIntervalChangeScreen()
        }.bind(this), this.countdownChangeScreen * 1000)
      } else {
        clearTimeout(this.intervalChangeScreen)
        this.screenScroller = this.screenScroller ? this.screenScroller.stop() : null
      }
    },
    scrollDown() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.toY(document.querySelector('#inner-monitor').offsetHeight - window.innerHeight, this.countdownChangeScreen / 2 * 1000, () => { this.scrollUp() })
    },
    scrollUp() {
      this.screenScroller = Zenscroll.createScroller(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, 50)
      this.screenScroller.to(document.getElementById('monitor'), this.countdownChangeScreen / 2 * 1000, () => { this.screenScroller = null })
    },
    clearTimeout() {
      this.connectionError = false
      clearTimeout(this.timeout)
      clearInterval(this.intervalCountdown)
      clearInterval(this.intervalConnectionError)
      this.countdown = 60
    },
    setIntervalCountdown() {
      clearInterval(this.intervalCountdown)
      this.countdown = 60
      this.intervalCountdown = setInterval(function () {
        this.countdown = this.countdown === 0 ? 0 : this.countdown - 1
      }.bind(this), 1000)
      if (!this.intervalChangeScreen) {
        this.setIntervalChangeScreen()
      }
    },
    setIntervalCountdownConnectionError() {
      clearInterval(this.intervalConnectionError)
      this.countdownConnectionError = 10
      this.intervalConnectionError = setInterval(function () {
        this.countdownConnectionError = this.countdownConnectionError === 0 ? 0 : this.countdownConnectionError - 1
      }.bind(this), 1000)
    },
    getSlots() {
      if (this.countryOverride && this.filterWarehouse) {
        let params = {
          includes: [
            'content',
            'tour.shippings',
            'tour.courier.courier_available.tracking',
            'warehouse'
          ],
          filter_groups: [{
            filters: [
              ['tour_id', 'eq', null, 'true'],
              ['warehouse_id', 'eq', this.filterWarehouse]
            ]
          }]
        }
        this.$http.get(this.$appConfig.api.baseUrl + 'warehouse-slots', {params: params})
          .then(response => {
            this.slots = response.body.data.map(x => this.categorizeSlot(x)).map(x => {
              x.routingZones = this.setShippingRoutingZones(x.tour.shippings)
              const confirmedAt = this.setConfirmedAt(x.tour.shippings)
              x.confirmedAt = confirmedAt ? this.elapsedTime(confirmedAt) : null
              try {
                x.distanceToDestination = this.setDistanceToDestination(x)
                x.readableDistanceToDestination = this.distance(x.distanceToDestination, true)
                const minutes = x.distanceToDestination / 1000 * 60 / this.averageSpeed
                x.eta = this.moment().startOf('day').add(minutes, 'minutes').format(minutes < 60 ? 'm' : 'hh:mm') + (minutes < 60 ? ' min' : ' hs')
              } catch (e) {
                x.distanceToDestination = 100000000000
                x.readableDistanceToDestination = null
              }
              return x
            })
              .sort((a, b) => a.code.localeCompare(b.code))
              .sort((a, b) => {
                if (a.distanceToDestination === null) {
                  return 1
                } else if (b.distanceToDestination === null) {
                  return -1
                }
                return a.distanceToDestination - b.distanceToDestination
              })
              .sort((a, b) => a.status.localeCompare(b.status))

            this.timeout = setTimeout(function () {
              this.getSlots()
            }.bind(this), 60000)
            this.setIntervalCountdown()
          }, () => {
            this.$root.$children[0].$refs.simplert.justCloseSimplert()
            this.connectionError = true
            this.setIntervalCountdownConnectionError()
            this.timeout = setTimeout(function () {
              this.getSlots()
            }.bind(this), 10000)
          })
          .finally(() => {
            this.working = false
            return true
          })
      }
    },
    setShippingRoutingZones(shippings) {
      const routingZones = shippings.map(x => {
        return x.routing_zone ? x.routing_zone.code : null
      }).filter(Boolean).reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
      return routingZones
    },
    setConfirmedAt(shippings) {
      shippings = shippings.filter(x => x.status === 'CONFIRMED').sort((a, b) => a.updated_at.replace(/\D/g, '') - b.updated_at.replace(/\D/g, ''))
      return shippings[0] ? shippings[0].updated_at : null
    },
    categorizeSlot(slot) {
      let badScanneds = slot.content.map(x => x.shipping_id).filter(x => !slot.tour.shippings.map(x => x.id).includes(x))
      if (badScanneds.length > 0) {
        slot.status = 'error'
        slot.badScanneds = badScanneds
        return slot
      }

      let notScanneds = slot.tour.shippings.map(x => x.id).filter(x => !slot.content.map(x => x.shipping_id).includes(x))
      if (notScanneds.length > 0) {
        slot.status = 'processing'
        slot.notScanneds = notScanneds
        return slot
      }

      slot.status = 'ready'
      return slot
    },
    rowBg(slot) {
      let bg
      switch (slot.status) {
        case 'processing':
          bg = 'bg-warning-light'
          break
        case 'error':
          bg = 'bg-danger-light'
          break
        case 'ready':
          bg = 'bg-success-light'
          break
        default:
          bg = 'bg-white'
      }
      return bg
    },
    isInViewport (elem) {
      let bounding = elem.getBoundingClientRect()
      return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    },
    setDistanceToDestination(slot) {
      return slot.tour.courier && slot.tour.courier.courier_available && slot.tour.courier.courier_available.tracking.length > 0 ? this.getDistance({lat: slot.warehouse.place.lat, lng: slot.warehouse.place.lng}, {lat: slot.tour.courier.courier_available.tracking[0].lat, lng: slot.tour.courier.courier_available.tracking[0].lng}) : null
    },
    setNewCountry() {
      if (this.countryOverride !== null) {
        this.fetchWarehousesById(this.countryOverride)
        this.filterWarehouse = null
        this.shippings = []
      } else {
        this.warehouses = []
        this.filterWarehouse = null
      }
    }
  }
}
</script>

<style lang="scss">
.wh-exit-monitor {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  overflow: auto;
  line-height: 1.3;
  .card {
    box-shadow: none !important;
  }
  .card-body {
    padding: 5px !important;
  }
}
#modalConfigMonitor___BV_modal_outer_ {
  z-index: 10040 !important
}
</style>
